// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__a4fu-","tabsBox":"styles_tabsBox__-KCkP","createButton":"styles_createButton__1LynZ"};